/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Overwrite_RequiredInputs */

const cs_templates_ai_overwrite_required = /** @type {(inputs: Templates_Ai_Overwrite_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapněte „Nahradit aktuální layout“, abyste mohli přepsat plátno.`)
};

const en_templates_ai_overwrite_required = /** @type {(inputs: Templates_Ai_Overwrite_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable “Replace current layout” to overwrite the canvas.`)
};

/**
* | output |
* | --- |
* | "Enable “Replace current layout” to overwrite the canvas." |
*
* @param {Templates_Ai_Overwrite_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_overwrite_required = /** @type {((inputs?: Templates_Ai_Overwrite_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Overwrite_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_overwrite_required(inputs)
	return cs_templates_ai_overwrite_required(inputs)
});